<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <slot />
    <g fill="none" fill-rule="evenodd" :stroke="color" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M14.102 7L8.25 12.982 6 10.482" />
      <path
        d="M19 10c0 2.485-1.007 4.735-2.636 6.364C14.735 17.993 12.485 19 10 19c-2.486 0-4.736-1.007-6.364-2.636C2.007 14.736 1 12.486 1 10c0-2.486 1.007-4.736 2.636-6.364C5.264 2.007 7.514 1 10 1c2.485 0 4.735 1.007 6.364 2.636C17.993 5.265 19 7.515 19 10z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
